import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Request, { ApiMode } from '../../utils/request';

const IS_LOCAL = false;

const PLAY_PLACE_ORDER_ENDPOINT = '/api/checkout/place-order';
const LICENCE_RENEWAL_PLACE_ORDER_ENDPOINT = '/api/payments/paylicence';
// TODO Confirm it with Gunjan
// const ACCREDITATION_RENEWAL_PLACE_ORDER_ENDPOINT = '/api/payments/paylicence'

export const ErrorCode = {
	PlaceOrderApiError: 'PlaceOrderApiError'
};

export const PaymentPage = {
	PLAY: 'play',
	LICENCE_RENEWAL: 'licenceRenewal',
	ACCREDITATION_RENEWAL: 'accreditationRenewal',
	YOUTH_STARTER_OFFER: 'youthStarterOffer'
};

export const placeOrder = (...arguments_) => {
	const page = window?.lta?.checkout?.screen;
	switch (page) {
		case PaymentPage.LICENCE_RENEWAL:
			return licenceRenewalPlaceOrder(...arguments_);

		// TODO confirm this with Gunjan
		case PaymentPage.ACCREDITATION_RENEWAL:
			return licenceRenewalPlaceOrder(...arguments_);

		case PaymentPage.PLAY:
		default:
			return playPlaceOrder(...arguments_);
	}
};

export const playPlaceOrder =
	(bookingToken, errorHandler, numberOfPlayers, extraParameters, playParkConsent) =>
	async ({ id }) => {
		startLoadingAnimation();
		try {
			const orderData = {
				paymentId: id,
				bookingToken,
				playParkConsent: playParkConsent,
				...extraParameters,
				...(numberOfPlayers && { numberOfPlayers: Number.parseInt(numberOfPlayers, 10) })
			};

			return await Request.post(PLAY_PLACE_ORDER_ENDPOINT, orderData);
		} catch (error) {
			console.error(error);
			const errorData = await error.text();
			errorHandler({ message: 'Unable to place order', isSubmissionError: true }, ErrorCode.PlaceOrderApiError);
			throw { message: 'Unable to place order', isSubmissionError: true, errorData };
		}
		finally {
			stopLoadingAnimation()
		}
		// eslint-disable-next-line unicorn/no-null
		return null;
	};

export const licenceRenewalPlaceOrder =
	(errorHandler) =>
	async ({ id, extraParam, screen }) => {
		try {
			const orderData = {
				paymentId: id,
				screen: screen,
				cardPaymentAsync: true, // NOTE - DO NOT COMMIT THIS LINE. TESTING LINE.
				...(window?.lta?.checkout?.extraParams ? window?.lta?.checkout?.extraParams : {}),
				...extraParam
			};
			return await Request.post(LICENCE_RENEWAL_PLACE_ORDER_ENDPOINT, orderData, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
		} catch (error) {
			console.error(error);
			const errorData = await error.text();
			errorHandler({ message: 'Unable to place order', isSubmissionError: true }, ErrorCode.PlaceOrderApiError);
			throw { message: 'Unable to place order', isSubmissionError: true, errorData };
		}
		// eslint-disable-next-line unicorn/no-null
		return null;
	};
